'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = require('./utils/track');

var _track3 = _interopRequireDefault(_track2);

var _events = require('./events');

var _traits = require('./traits');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionDetailsCompleted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 2), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_NAME, traits[_traits.TRAIT_PRODUCT_NAME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_PRICE, traits[_traits.TRAIT_PRODUCT_PRICE]), _track));
}

exports.default = trackSubscriptionDetailsCompleted;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/trackSubscriptionDetailsCompleted.js
// module id = 1961
// module chunks = 1